/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppLink from '../../shared/components/app-link/AppLink';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import { debounce } from '../../api/apiUtils';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';

function TopupReceiptList({ topupReceiptList }) {
  const [receiptList, setReceiptList] = useState([]);
  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    setReceiptList(topupReceiptList);
  }, [topupReceiptList]);

  const setSearchResults = debounce((val) => {
    if (topupReceiptList.length > 0) {
      let data = [...topupReceiptList];
      if (val !== '') {
        data = data.filter((o) =>
          Object.keys(o).some(
            (k) =>
              o[k] !== null &&
              o[k] !== undefined &&
              o[k].toString().toLowerCase().includes(val.toLowerCase()),
          ),
        );
      }
      setReceiptList(data);
    }
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  const getReceipt = (txid) => {
    let route = NAVIGATION_ROUTES.TOP_UP_RECEIPT;
    route = route.replace(':transactionId', txid);
    return route;
  };
  return (
    <section className="credit-debit-list">
      <div className="credit-debit-list_container">
        <div className="m-3 d-flex">
          <div style={{ width: '300px' }}>
            <AppTextInput
              value={searchText}
              label="search"
              onChange={handleSearch}
            />
          </div>
        </div>
        <table className="mb-3">
          <thead>
            <tr>
              <th>Receipt ID</th>
              <th>Receipt Date</th>
              <th>Mode</th>
              <th>Details</th>
              <th>Payed By</th>
              <th>Deposited Bank</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {receiptList.map((receipt) => (
              <tr key={receipt.Txid}>
                <td>{receipt.Txid}</td>
                <td className="background-color">{receipt.TxDate}</td>
                <td>{receipt.PaymentMode}</td>
                <td>{receipt.Details}</td>
                <td>{receipt.AgentId}</td>
                <td>{receipt.DepositedBank}</td>
                <td>{receipt.DepositedAmount}</td>
                <td>{receipt.Status}</td>
                <td>
                  <AppLink
                    linkText="Receipt"
                    isLink
                    href={getReceipt(receipt.Txid)}
                    target="_blank"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

TopupReceiptList.propTypes = {
  topupReceiptList: PropTypes.array.isRequired,
};

export default TopupReceiptList;
